module.exports = __webpack_public_path__ + "static/media/phone-bg.c69a0a62.jpg";